// src/plugins/vuetify.js
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css'

import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi'; // For icons
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { VDataTable } from 'vuetify/components'

// Import VTreeview from Labs
import { VTreeview } from 'vuetify/labs/VTreeview';

export default createVuetify({
  components: {
    ...components,
    VTreeview, // Add VTreeview to the components
    VDataTable,
  },
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
});
